import { createFileRoute, redirect } from '@tanstack/react-router';

import { connectionsSearchSchema } from '@/components/connectors/connections-search';
import { ROUTES } from '@/constants/routes';

// Old links and bookmarks still land here.
export const Route = createFileRoute('/_authenticated/settings/connections')({
  validateSearch: connectionsSearchSchema,
  beforeLoad: ({ search }) => {
    // eslint-disable-next-line @typescript-eslint/only-throw-error
    throw redirect({ to: ROUTES.CONNECTORS, search, replace: true });
  },
});
